export var SellingPointsTags;
(function (SellingPointsTags) {
    SellingPointsTags["amex"] = "AMEX";
})(SellingPointsTags || (SellingPointsTags = {}));
export var RedirectTarget;
(function (RedirectTarget) {
    RedirectTarget["issuerSite"] = "Issuer Site";
    RedirectTarget["quoteComparison"] = "Quote comparison";
    RedirectTarget["interview"] = "Interview";
    RedirectTarget["callTobind"] = "Call to bind";
    RedirectTarget["paymentCollection"] = "Payment collection";
    RedirectTarget["callToQuote"] = "Call to quote";
})(RedirectTarget || (RedirectTarget = {}));
export var Channel;
(function (Channel) {
    Channel["online"] = "Online";
    Channel["phone"] = "Phone";
    Channel["sms"] = "SMS";
})(Channel || (Channel = {}));
